import { useGetPermissions } from 'layouts/customHook';
import React from 'react';
import ArpuWorkflow from './ArpuWorkflow';
import { PermisionDenied } from '../../common/commonComponents';

const ArpuWorkflowWrapper=()=>{
    return (
         <ArpuWorkflow/>
    );
}
export default ArpuWorkflowWrapper;